module.exports = {
  list: {
    remove: {
      prompt: (file) => `Do you really want to delete file ${file.name} ?`,
      yes: "Yes",
      no: "No"
    },
    loading: "Loading File List..."
  },

  loadFromCloud: "Load from cloud",
  upload: "Upload",

  loaded: (fileName) => `File ${ fileName } loaded!`,
  loadError: (error) => `File load impossible - ${ error }`,
  ok: "Ok",
  fileNamePlaceholder: "File name",

  saveToCloud: "Save to cloud",
  download: "Download",
  fileSaved: (fileName) => `File ${ fileName } saved!`,
  saveError: (error) => `File save impossible - ${ error }`



}


// WEBPACK FOOTER //
// ../i18n/en/save.js